import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PasswordService } from '../../services/password/password.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email_id: string;
  successMessage: string;
  errMessage: string;
  msgAlign : boolean = false;

  reEmail = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
  constructor(private router: Router, private passwordService: PasswordService) { }

  ngOnInit() {
    
  }

  forgotPassword() {
    if (this.email_id && this.reEmail.test(this.email_id)) {
      this.passwordService.sendEmail(this.email_id).subscribe(res => {
        if (res.Status === 200) {
          if (res.Info === 'No Data Found') {
            this.errMessage = 'Please try with valid Email';
            this.msgAlign = false;
          } else {
            this.errMessage = '';
            this.successMessage = res.Info;
          }
        } else if (res.Status == 403){
          this.errMessage = ' Your User ID is Blocked. Please contact Client Relations at parclientrelations@parnorthamerica.com ';          
          this.msgAlign = true;
        }
      }, err => {
      });
    } else {
      this.errMessage = 'Please Enter valid Email';
      this.msgAlign = false;
    }
  }

  backToLogin() {
    this.router.navigate(['/home']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forgot-password/forgot-password.component.ts